import axios from 'axios';
import { generateChecksumForEncrypted, validateChecksum } from './checksum';

class Service {

  getRestClient(guId, basic) {
   
    this.serviceInstance = axios.create({
      baseURL: '/InsertInstructions',
      timeout: 50000,
      headers: {
        'Content-Type': 'text/plain',
        guId: guId,
        'Authorization': basic
      },
    });

    // Request interceptor - Add checksum to requests
    this.serviceInstance.interceptors.request.use(
      (config) => {
        if (config.data) {
          const checksum = generateChecksumForEncrypted(config.data);
          if (checksum) {
            config.headers['checksum'] = checksum;
          }
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Response interceptor - Validate checksum from responses
    this.serviceInstance.interceptors.response.use(
      (response) => {
        // Check for checksum in response headers (case-insensitive)
        const headers = response.headers || {};
        const receivedChecksum = headers['checksum'] || 
                                 headers['Checksum'] || 
                                 headers['x-checksum'] || 
                                 headers['X-Checksum'];
        const responseData = response.data;

        if (receivedChecksum && responseData) {
          // Ensure responseData is treated as string for validation
          const dataString = typeof responseData === 'string' ? responseData : String(responseData);
          const isValid = validateChecksum(dataString, receivedChecksum);
          if (!isValid) {
            console.error('Checksum validation failed');
            return Promise.reject(new Error('Checksum validation failed'));
          }
        }

        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    return this.serviceInstance;
  }
}

export default (new Service());